import React from "react"

function TableHead({
  headerGroups,
  onHeaderClick,
  generateSortingIndicator,
  widthControl,
  tableHeader,
  sortingTotalHours,
  setExpandedRow 
}) {
  return (
    <thead
      className="table-light table-center"
      style={{
        visibility: tableHeader == "hide" && "collapse",
      }}
    >
      {headerGroups.map(headerGroup => (
        <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map(column => (
            <th
              key={column.id}
              onClick={() => {
                setExpandedRow(null);
              }}
            >
              <div
                className={widthControl ? "mb-2 widthControl" : "mb-2"}
                {...column.getSortByToggleProps()}
              >
                {column.render("Header")}
                {generateSortingIndicator(column)}
              </div>
            </th>
          ))}
        </tr>
      ))}
    </thead>
  )
}

export default TableHead
